// Données de formulaire d'un dossier rendues selon le schéma de la version de sa démarche
// (sections, libellés, options par leur libellé, tableaux). Si la version n'est pas au format de
// l'éditeur (démarche interne de test), les données sont listées telles quelles.
import { schemaFormulaire } from '@cc/contrats';
import type { DossierDetail } from '@cc/contrats/ui-metier';
import { Squelette } from '@cc/ui';
import { useMemo } from 'react';
import { AffichageDonnees } from '../../../formulaire/AffichageDonnees';
import { useVersion } from '../../demarches/contenu';
import commun from '../../../commun/commun.module.css';

export function DonneesFormulaireDossier({ dossier: d }: { dossier: DossierDetail }) {
  const version = useVersion(d.demarche.id, d.demarche.numero_version);
  const formulaire = useMemo(() => {
    const r = schemaFormulaire.safeParse((version.data?.contenu as { formulaire?: unknown } | undefined)?.formulaire);
    return r.success ? r.data : null;
  }, [version.data]);
  if (version.isPending) return <Squelette lignes={4} />;
  const pieces = Object.fromEntries(d.pieces.map((p) => [p.document_id, p.titre]));
  return (
    <div>
      {version.error ? <p className={commun.na}>Schéma de la version non lisible : données affichées sans mise en forme.</p> : null}
      <AffichageDonnees formulaire={formulaire} donnees={d.donnees_formulaire ?? {}} pieces={pieces} />
    </div>
  );
}
